(function () {
  var TRACKING_CODE_PATTERN = /^AFF-[A-Z0-9]+-[A-Z0-9-]+$/;
  var STORAGE_KEY = "tap_affiliate_ref";
  var DEFAULT_WINDOW_DAYS = 30;
  var ATTRIBUTE_KEYS = {
    code: "affiliate_ref",
    capturedAt: "affiliate_ref_captured_at",
    expiresAt: "affiliate_ref_expires_at",
    source: "affiliate_ref_source",
  };

  function detectStore() {
    var host = window.location.hostname.toLowerCase();

    if (host.indexOf("skinii") !== -1) return "skinii";
    if (host.indexOf("ragers") !== -1) return "ragers";

    return null;
  }

  function getWindowDays() {
    var value = Number(window.__tapAffiliateWindowDays);

    if (!Number.isFinite(value) || value < 1) {
      return DEFAULT_WINDOW_DAYS;
    }

    return Math.floor(value);
  }

  function buildCandidateFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var rawRef = params.get("ref");

    if (!rawRef) return null;

    var normalized = rawRef.trim().toUpperCase();

    if (!normalized) return null;
    if (!TRACKING_CODE_PATTERN.test(normalized)) return null;

    var capturedAt = new Date();
    var expiresAt = new Date(
      capturedAt.getTime() + getWindowDays() * 24 * 60 * 60 * 1000
    );

    return {
      code: normalized,
      source: "query.ref",
      store: detectStore(),
      capturedAt: capturedAt.toISOString(),
      expiresAt: expiresAt.toISOString(),
    };
  }

  function readStoredCandidate() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var parsed = JSON.parse(raw);

      if (
        !parsed ||
        typeof parsed.code !== "string" ||
        typeof parsed.capturedAt !== "string" ||
        typeof parsed.expiresAt !== "string"
      ) {
        return null;
      }

      if (!TRACKING_CODE_PATTERN.test(parsed.code)) {
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function isExpired(candidate) {
    var expiresAt = new Date(candidate.expiresAt).getTime();

    if (!Number.isFinite(expiresAt)) return true;

    return Date.now() > expiresAt;
  }

  function clearStoredCandidate() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function storeCandidate(candidate) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(candidate));
    } catch (error) {}
  }

  function getActiveCandidate() {
    var queryCandidate = buildCandidateFromQuery();

    if (queryCandidate) {
      storeCandidate(queryCandidate);
      return queryCandidate;
    }

    var storedCandidate = readStoredCandidate();

    if (!storedCandidate) return null;

    if (isExpired(storedCandidate)) {
      clearStoredCandidate();
      return null;
    }

    return storedCandidate;
  }

  function buildCartAttributes(candidate) {
    return {
      attributes: {
        affiliate_ref: candidate.code,
        affiliate_ref_captured_at: candidate.capturedAt,
        affiliate_ref_expires_at: candidate.expiresAt,
        affiliate_ref_source: candidate.source,
      },
    };
  }

  function canUpdateCartAttributes() {
    return (
      window.routes &&
      typeof window.routes.cart_update_url === "string" &&
      window.routes.cart_update_url.length > 0
    );
  }

  function attachTrackingToCart(candidate) {
    if (!canUpdateCartAttributes()) return Promise.resolve();

    return fetch(window.routes.cart_update_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(buildCartAttributes(candidate)),
      credentials: "same-origin",
    }).catch(function () {});
  }

  var activeCandidate = getActiveCandidate();

  if (!activeCandidate) return;

  window.__tapAffiliateTrackingCandidate = activeCandidate;

  attachTrackingToCart(activeCandidate);

  console.log("[affiliate-tracking] active candidate", {
    code: activeCandidate.code,
    source: activeCandidate.source,
    store: activeCandidate.store,
    expiresAt: activeCandidate.expiresAt,
  });
})();
